import { useQuery } from '@tanstack/react-query';
import { getPropertyEntryMethodPreference } from '../../property/service';

function usePropertyEntryMethodPreference(
    { propertyId }: { propertyId: number }
) {
    const query = useQuery({
        queryKey: ['property', propertyId, 'entry-method-preferences'],
        queryFn: () => getPropertyEntryMethodPreference(propertyId),
    });

    return query;
}

export { usePropertyEntryMethodPreference };
